




import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import DiscountValue from '@/modules/shared/components/admin/discount-change/DiscountValue.vue'
import { ContentItemStatus } from '@/modules/content-item/models/content-item-resource.model'
import {
  AdminContentItemManualDiscountUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-manual-discount.use-case'
import ProfitValue from '@/modules/profit/components/admin/ProfitValue.vue'
import {
  AdminContentItemChangeProfitUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-change-profit.use-case'

@Component({
  components: {
    TesTr
  }
})
export default class AdminContentItemFinancialTableRow extends mixins(TesTableRow) {
  constructor(
    private readonly discountUseCase: AdminContentItemManualDiscountUseCase,
    private readonly profitUseCase: AdminContentItemChangeProfitUseCase
  ) {
    super()
  }

  columnComponents = {
    manual_discount: {
      component: DiscountValue,
      handler: (value, row) => ({
        class: 'justify-center',
        amount: value,
        editable: ContentItemStatus.WAITING_PAYMENT === row.status,
        id: row.id,
        useCase: this.discountUseCase
      })
    },
    profit: {
      component: ProfitValue,
      handler: (value, row) => ({
        class: 'justify-center',
        amount: value,
        editable: ContentItemStatus.WAITING_PAYMENT !== row.status,
        useCase: this.profitUseCase,
        id: row.id
      })
    }
  }
}
